module.exports = __webpack_public_path__ + "img/Fiche chargé de communication vie associative.ebef9965.jpg";